import { PermisosService, Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy, Input, ViewChild, OnChanges, Output, HostListener } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService, LangChangeEvent } from 'ng2-translate';
import { Constantes } from '../../domain/constantes';
import { AppComponent } from '../../app.component';
import { Message, SelectItem } from 'primeng/primeng';
import { Tablita } from '../../domain/Tablita';
import { InformesService } from '../../providers/informes/informes.service';
import { Contenido } from '../../domain/Contenido';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { Predicate } from '../../../../node_modules/breeze-client';
import { Compass } from '../../domain/compass';
import { ConexionPlano, ContenidoPlano, NodoPlano, SeccionPlano, PlanoComponent} from 'interiores-mapa';
import { NotificacionPlano } from 'interiores-mapa/dist/notificacionPlano';
import { BeaconPlano } from 'interiores-mapa/dist/beaconPlano';
import { BalizaFormulario } from '../../domain/BalizaFormulario';
import { SeccionFormulario } from '../../domain/SeccionFormulario';
import { NodoFormulario } from '../../domain/NodoFormulario';
import * as d3RadialMenu from 'd3-radial-menu';
import { AlaFormulario } from '../../domain/AlaFormulario';
import { VerticalManager, Vertical, Planta } from '../../domain/Vertical';

@Component({
    selector: 'app-localizacionchart',
	templateUrl: './localizacionChart.component.html',
	styleUrls: ['./localizacionChart.component.scss'],
    providers: [ConfirmationService]
})
export class AppLocalizacionChartComponent implements OnInit, OnDestroy, OnChanges  {
	@Input() contenidosList: Contenido[] = [];
	@Input() tipologiasList = [];

	@ViewChild('dt') dt;

	@HostListener("window:scroll", ['$event'])
	doSomethingOnWindowsScroll($event:Event){
		let target = $event.srcElement as HTMLTextAreaElement;
	 	this.scrollTop = target.children[0].scrollTop;
	}

	listaNiveles: any[] = [];

	spinner: HTMLElement;
	msgs: Message[] = [];

	secciones = [];
	plantaSeleccionada: Planta;

	nombrePlanta: String;
	pathPlano: String;
	zoomLevels: Number[]= [1, 1];
	contents: ContenidoPlano[] = [];
	currentZoomLevel: number;
	zoomLevelsVisibilityLabels: Number[] = [1, 100];

	/*
		pathPlano: String;
		currentZoomLevel: number = 1;
		zoomLevels: Number[];
		pathSvgPlano: string;
		compass: Compass;
		cursorPointer: string = '';
		fechaVisualizacion: Date = new Date();

		@ViewChild('plano') plano: PlanoComponent;
	*/

	puntos = [];
	radius = 250;
	opacity = 0.5;
	estado = 'center';



	public Informes: Contenido[] = [];
	public Tabla: Tablita[] = [];

    public cols;

	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	public permisos: Permisos = new Permisos();

	public fAltaError = false;
	public fBajaError = false;

	public opcionesSelectorTipologia: SelectItem[]  = [];

	verticalManager: VerticalManager;
	verticales: Vertical[] = [];
	mapaPantallaCompletaVisible: boolean;

	//tipologiasList;
	tipologia_Filter: string;

	public dialogContenidosApilados: boolean = false;
	public contenidosApilados: any;
	public positionDialogContenidosApiladosX: number;
	public positionDialogContenidosApiladosY: number;
	public positionDialogInfoInformeY: number;
	public positionDialogInfoInformeX: number;
	public dialogDescripcionInforme: boolean = false;
	public scrollTop: number = 0;

	constructor(
		private appComponent: AppComponent,
		private router: Router,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService,
		private permisosService: PermisosService,
		private informeService: InformesService
	) {

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Informes.Informes') }
		]);

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
        this.spinner.style.display = 'none';

		// Tabla Localizacion Tiempo Real
		this.cols = [
			{ field: 'Titulo', header: this.translate.instant('Informes.Elemento'), visible: true, width: '20%' },
			{ field: 'Descripcion', header: this.translate.instant('Informes.Descripcion'), visible: true, width: '20%' },
			{ field: 'Tipo', header: this.translate.instant('Informes.Tipologias'), visible: true, width: '15%' },
			{ field: 'PermaneceDesde', header: this.translate.instant('Informes.PermaneceDesde'), visible: false, width: '15%' },
			{ field: 'TiempoDesdeUltimaLocalizacion', header: this.translate.instant('Informes.TiempoDesdeUltimaLocalizacion'), visible: true, width: '15%' },
			{ field: 'Seccion', header: this.translate.instant('Informes.Seccion'), visible: true, width: '15%' },
			{ field: 'Localizacion', header: '', visible: false, width: '0%'}
		];

		this.contenidosApilados = [];
    }


	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		this.spinner.style.display = 'inherit';
		//mando tabla a pagina 1
		if(typeof that.dt !==  'undefined'){
			this.dt.first = 0;
		}
		if (!this.verticalManager) {
			this.verticalManager = new VerticalManager();
		}

		this.cargarEntidades()
		.then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
		})
		.catch(function(){
			console.log('*** Error: ngOnInit ***');
		});

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	ngOnChanges($event) {
		//mando tabla a pagina 1
		if(typeof this.dt !==  'undefined'){
			this.dt.first = 0;
		}
		if (!this.verticalManager) {
			this.verticalManager = new VerticalManager();
		}
		this.cargarEntidades()
		.then(function () {
			// Ocultamos Spinner
			this.spinner.style.display = 'none';
		})
		.catch(function(){
			console.log('*** Error: ngOnChanges ***');
		});
		if (this.plantaSeleccionada ) {
			this.cargarPlano(this.plantaSeleccionada );
		}
	}
	filterTipologia(event, columna) {
		this.dt.filter(event.Nombre, columna, 'equals');
	}

	tipoPintar(event){
		const aux = event.Tipo;
		return aux;
	}

	filterLocalizacion(value, field, op){
		this.dt.filter(value, 'Localizacion', op);
	}

    setScale(contenedorPlano, anchoMapa) {
        return (contenedorPlano.offsetWidth - 30) / anchoMapa;
    }

	verPlanoPlanta(event: Planta) {
		this.spinner.style.display = 'inherit';
		this.cargarPlano(event);
		this.mapaPantallaCompletaVisible = true;
	}

	ocultarPlanoPlanta(event: Planta) {
		this.mapaPantallaCompletaVisible = false;
	}


	cargarEntidades(): Promise < any > {
		const that = this;

		return this.comprobarPermisos()
		.then(function(){
			return that.obtenerNIVEL();
		})
		.then(function(niveles) {
			niveles.forEach(nivel => {
				for (let index = 0; index < nivel.ALAS.length; index++) {
					if (index === nivel.ALAS.length - 1) {
						const ala = nivel.ALAS[index];
						ala.esLaUltima = true;
					}
				}
			});
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}


	obtenerNIVEL() {
		const that = this;
		const entityManager = that.entityManager;

		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		let includes = 'ESPACIO';
		includes = includes + ', IDIOMAS.IDIOMA';
		// includes = includes + ', ALAS.SECCIONS';
		includes = includes + ', ALAS.IDIOMAS.IDIOMA';
		// includes = includes + ', ALAS.SECCIONS.NODOS.CONTENIDOS.CONTENIDO.TIPOLOGIA_CONTENIDO';

		return entityManager.getNIVEL(predicado, includes)
		.then(function(niveles){
			if (niveles) {
				let nivelAlas = niveles.find(n => n.ALAS.length > 1);
				that.listaNiveles = niveles;
				if(nivelAlas){
					that.verticales = that.verticalManager.generarVerticalesFromNIVELES(niveles);
				}else{
					that.verticales = that.verticalManager.generarVerticalesFromESPACIO(niveles);
					console.log(that.verticales)
				}
				that.verticalManager.asignarContenidosAVerticales(that.verticales, that.contenidosList, nivelAlas);

			}
			return that.listaNiveles;

		})
		.catch(function(e){
			console.error(e);
			that.appComponent.showError(e.message);
			return false;
		});
	}

	public onSVGLoaded(event, alaSeleccionada) {
		if (this.plantaSeleccionada) {
			this.contents = this.verticalManager.getContenidosPlano(this.plantaSeleccionada);
			this.contents = Object.assign([], this.contents);
		}
		//ocultar  Spinner
		this.spinner.style.display = 'none';
	}

	cargarPlano(event) {
		this.plantaSeleccionada = event;
		this.zoomLevels = [this.plantaSeleccionada.Ala.zoomMinimo, this.plantaSeleccionada.Ala.zoomMaximo];
		this.zoomLevelsVisibilityLabels = this.zoomLevels;
		this.currentZoomLevel = 1;
		const cambioPlano = this.plantaSeleccionada.Ala.RutaImagen !== this.pathPlano;
		this.pathPlano = this.plantaSeleccionada.Ala.RutaImagen;
		this.nombrePlanta = this.plantaSeleccionada.Nombre;
		// Si no cambio el plano no se va a llamar a onSVGLoad y no se refrescan los contanidos asi que los refresco manualmente
		if (!cambioPlano){
			if (this.plantaSeleccionada) {
				this.contents = this.verticalManager.getContenidosPlano(this.plantaSeleccionada);
				this.contents = Object.assign([], this.contents);
			}
		}
	}

    /****** AUX ********/
	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

	public onContentClicked(event){
		this.dialogContenidosApilados = false;
		setTimeout(() => {


		
		this.positionDialogContenidosApiladosX = event.event.x - 200;
		if(event.event.y > 400){
			this.positionDialogContenidosApiladosY = event.event.y + this.scrollTop - 330;
		}else{
			this.positionDialogContenidosApiladosY = event.event.y + this.scrollTop + 20;
		}
		



		let x = event.x;
		let y = event.y;
		this.contenidosApilados = [];
		this.contenidosList.forEach(element => {
			if(element.X === x && element.Y === y){
				let contenidoSimbolo = this.contents.find(contenido => contenido.getId() === element.Id);
				let simbolo: string = contenidoSimbolo.getSimbolo().toString();
				element.CONTENIDO_PLANO.setSimbolo(simbolo);
				this.contenidosApilados.push(element);
			}
		});
		if(this.contenidosApilados.length > 1){
			this.dialogContenidosApilados = true;
		}

		}, 500);
		
	}

	descripcionInforme(event){
		console.log(event)
		this.positionDialogInfoInformeX = event.x;
		this.positionDialogInfoInformeY = event.y;
		this.dialogDescripcionInforme = !this.dialogDescripcionInforme;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/LocalizacionChart/localizacionChart.component.ts